import { useEffect } from "react";

// Sets document.title to "<name> · Eminity" while mounted; restores
// the previous title on unmount so back-navigation between routes
// doesn't leak titles (0028).
export function useDocumentTitle(name: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title;
    document.title = name ? `${name} · Eminity` : "Eminity";
    return () => {
      document.title = previous;
    };
  }, [name]);
}
